export default {
  buttons: {
    apply: "Применить",
    cancel: "ОТМЕНИТЬ",
    dismiss: "Закрыть",
    minimize: "уменьшать",
    unminimize: "увеличивать",
    add_waypoint: "добавить пункт назначения"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "миля"
    }
  },
  search: {
    title: "Поиск",
    placeholder: "Введите место",
    enter_location: "Введите место",
    recent_searches: "Последний поиск",
    suggestions: "Рекомендации",
    geolocation: "Использовать мою позицию",
    help: {
      inactive: "Поиск",
      clear: "Очистить"
    }
  },
  filters: {
    title: "Фильтры",
    more: "Больше фильтров",
    less: "Меньше фильтров",
    group: {
      more: "Больше",
      less: "Меньше"
    },
    amenities: {
      title: "Услуги и удобства"
    },
    fuels: {
      title: "Виды топлива"
    }
  },
  directions: {
    title: "Планирование маршрута",
    help: {
      add_waypoint: "Добавить путевую точку",
      reverse: "Поменять напровление",
      sort_waypoint: "Перетащите, чтобы изменить порядок",
      remove: "Убрать путевую точку"
    },
    placeholder: {
      origin: "Выберите пункт отправки",
      destination: "Введите место",
      waypoint: "Введите место"
    },
    route: {
      title: "Параметры маршрута",
      title_avoid: "Избежать",
      avoid_tolls: "Избегать платных дорог",
      avoid_highways: "Избегать автострад",
      avoid_ferries: "Избегать паромов",
      title_corridor: "Расстояние от маршрута до станций технического обслуживания"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# неделя} other {# недели}}
{days, plural, =0 {} =1 {# день} other {# дней}}
{hours, plural, =0 {} =1 {# час} other {# часы}}
{minutes, plural, =0 {} =1 {# мин} other {# мин}}\
`,
    button: "Поиск",
    error: "Не удалось обработать ваш маршрут. Пожалуйста, попробуйте еще раз"
  },
  action_panel: {
    back_to_results: "Назад к поиску"
  },
  locations: {
    title: "места",
    closed_temporarily: "Временно закрыто",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} от {place}",
    description: "{visible, select, true {Скрыть} false {Показать} }"
  },
  info_window: {
    back_to_results: "Назад к поиску",
    title: "Информация о станции",
    location_id: "ID Станции",
    website: "Вебсайт",
    services: "Услуги и удобства",
    nearby: "Рядом",
    directions: "Добавить к планировщику маршрутов",
    mobile: {
      telephone: "Телефон:"
    },
    opening_hours: {
      title: "Часы открытия и закрытия",
      mon: "Пн",
      tue: "Вт",
      wed: "Ср",
      thu: "Чт",
      fri: "Пт",
      sat: "Сб",
      sun: "Вс",
      open_twentyfourhours: "Открыто 24 часа",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Доступны цены на топлива",
      not_available: "Доступное топливо",
      price: "{price, number, fuelPrice}",
      disclaimer: "Вся информация предоставляется без гарантии: цены на колонке являются действительными.",
      last_updated_on: "Последний раз обновлено",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Планирование маршрута"
  },
  fuels: {
    autogas_lpg: "Автогаз (LPG)",
    midgrade_gasoline: "Shell 95",
    premium_diesel: "Shell V-Power dīzeļdegviela",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell dīzeļdegviela",
    super_premium_gasoline: "Shell V-Power Racing",
    unleaded_super: "Shell 95"
  },
  amenities: {
    air_and_water: "Воздух",
    atm_in: "Приём наличных денег",
    atm_out: "Выдача денег",
    atm: "Банкомат",
    austrian_highway_sticker: "Австрийская виньетка",
    bakery_shop: "Булочная",
    bank_note_acceptor: "Банкомат",
    bottled_gas: "Обмен газового баллона для BBQ (пропан)",
    carwash: "Мойка",
    childs_toilet: "Туалет или детский туалет",
    clubsmart_card: "Карта Shell ClubSmart",
    credit_card_american_express: "Кредитная карта - American Express",
    credit_card_diners_club: "Кредитная карта - Dinners Club",
    credit_card_general: "Кредитная карточка",
    credit_card_mastercard: "Кредитная карта - Mastercard",
    credit_card_visa: "Кредитная карта - Visa",
    credit_card: "Кредитная карточка",
    czech_highway_sticker: "Чешская виньетка",
    disability_assistance: "Помощь инвалидам",
    disabled_facilities: "Удобства для инвалидов",
    euroshell_card: "euroShell / Shell Card",
    fleet_card_eni: "Корпоративная карточка - Eni",
    fleet_card_esso: "Корпоративная карточка - Esso",
    fleet_card_general: "Корпоративная карточка",
    fleet_card_uta: "Корпоративная карточка - UTA",
    food_offerings: "Предложения по еде",
    fuel_card: "Топливные карточки",
    full_service: "Заправщик",
    guarded_car_park: "Охраняемая парковка",
    hgv_lane: "Дружелюбная к грузовым машинам",
    high_speed_diesel_pump: "Высокоскоростная подача дизеля ",
    hot_food: "Горячая еда",
    hungarian_highway_sticker: "Венгерская виньетка",
    jet: "Jet wash / Мытье машины под напором воды",
    loyalty_cards: "Карточки лояльности",
    mobile_payment: "Мобильная оплата",
    motorway_service: "Автострадный сервис",
    parking_lanes: "Парковка",
    partner_loyalty_accepted: "Принемается система лояльности партёров",
    pay_at_pump: "Оплата у колонки",
    quick_lubes: "Быстрые смазки",
    restaurant: "Ресторан",
    self_service: "Самообслуживание",
    service_bay: "Сервисный островок",
    shell_card: "euroShell / Shell Card",
    shell_club_smart_extra_card: "Карта Shell ClubSmart Extra",
    shop: "Магазин",
    shower: "Душ",
    slovak_highway_sticker: "Словацкая виньетка",
    snack_food: "Закуски / Fast food",
    standard_toilet: "Туалет",
    supermarket_fuel_discount: "Скидка на топливо",
    toilet: "Туалет",
    truck_parking: "Парковка для грузовиков",
    truckport: "Только для грузовиков",
    twenty_four_hour: "24 часа",
    unmanned: "Без персонала",
    vacuum: "Пылесос",
    vehicle_identity_system: "Система распознавания машин"
  },
  settings: {
    title: "Настройки",
    tooltip: "Настройки",
    traffic: "Трафик",
    distance_units: {
      title: "Расстояние",
      km: "километры",
      miles: "мили"
    },
    language: {
      title: "Язык",
      locales: {
        es_AR: "Аргентина испанский",
        en_AU: "Австрия английский",
        de_AT: "Австрия немецкий",
        fr_BE: "Бельгия французский",
        nl_BE: "Бельгия голланский",
        pt_BR: "Бразилия португальский",
        en_BG: "Болгария английский",
        bg_BG: "Болгария болгарский",
        fr_CA: "Канада французский",
        en_CA: "Канада английский",
        cz_CZ: "Чехия чешский",
        da_DK: "Дания датский",
        fi_FI: "Финляндия финский",
        fr_FR: "Франция французский",
        de_DE: "Германия немецкий",
        en_HK: "Гонконг английский",
        zh_HK: "Гонконг китайский (традиционный)",
        hu_HU: "Венгрия венгерский",
        en_IN: "Индия английский",
        en_ID: "Индонезия английский",
        id_ID: "Индонезия индонезийский",
        it_IT: "Италия итальянский",
        lv_LV: "Латвия латышский",
        lt_LT: "Литва литовский",
        fr_LU: "Люксембург французский",
        en_LU: "Люксембург английский",
        en_MY: "Малазия английский",
        en_MO: "Макао английский",
        zh_MO: "Макао китайский (традиционный)",
        nl_NL: "Нидерланды голланский",
        nb_NO: "Норвегия норвежский (Букмал)",
        en_OM: "Оман английский",
        ar_OM: "Оман арабский",
        en_PK: "Пакистан английский",
        ur_PK: "Пакистан урду",
        en_PH: "Филиппины английский",
        pl_PL: "Польша польский",
        es_PR: "Пуэрто-Рико испанский",
        ro_RO: "Румыния румынский",
        ru_RU: "Россия русский",
        en_SG: "Сингапур английский",
        sk_SK: "Словакия словацкий",
        sl_SI: "Словения словенский",
        en_ZA: "ЮАР английский",
        sv_SE: "Швеция шведский",
        fr_CH: "Швейцария французский",
        de_CH: "Швейцария немецкий",
        th_TH: "Таиланд тайский",
        tr_TR: "Турция турецкий",
        uk_UA: "Украина украинский",
        en_GB: "Великобритания английский",
        en_US: "США английский"
      }
    }
  },
  geolocation: {
    tooltip: "Использовать мою позицию"
  }
}
